import fetch from './fetch';

const targetAndOrgAnalysis = (data) => {
    return fetch.post('targetandorg/analysisByTermOrYear', data)
    .then(response => {
        if(response.code == 200) {
            return {
                dataSource: response.payload.data,
                max: response.payload.meta.extParams.maxValue,
                min: response.payload.meta.extParams.minValue,
                termList: response.payload.meta.extParams.termList
            }
        }else {
            return {
                dataSource: [],
                max: 0,
                min: 0,
                termList: []
            }
        }
    })
}

export default {
    targetAndOrgAnalysis
}